<template>
	<div class="event-speaker-card__speaker">
		<div @click="goToSpeaker" class="d-flex align-center u-cursor-pointer">
			<Avatar
				class="event-speaker-card__speaker-avatar"
				:size="52"
				:avatar="speaker.speaker_logo"
				:defaultAvatar="'speaker'"
				:color="'#ffffff'"
			/>
			<div class="event-speaker-card__speaker-info">
				<p class="event-speaker-card__speaker-name">
					{{ speaker.speaker_name }}
				</p>
				<p class="event-speaker-card__speaker-title">
					{{ speaker.speaker_title }}
				</p>
				<p class="event-speaker-card__speaker-title">
					{{ speaker.speaker_company }}
				</p>
			</div>
		</div>
		<button @click="addToBookmark" type="button">
			<Icon
				:type="bookmarked ? 'bookmark' : 'bookmark_empty'"
				color="var(--button-icon-tint)"
				:size="24"
			/>
		</button>
	</div>
</template>
<script>
import Avatar from '@/components/Avatar'
import { mapActions, mapGetters } from 'vuex'
import Dwh from '@/mixins/Dwh'

export default {
	data() {
		return {
			bookmarked: null,
		}
	},
	mixins: [Dwh],
	components: {
		Avatar,
	},
	props: {
		speaker: {
			type: Object,
			default: () => ({}),
		},
		isMyBookmark: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		speaker: {
			handler() {
				this.bookmarked = this.speaker.bookmark.is_bookmarked
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions('event', ['toggleBookmark']),
		async addToBookmark() {
			const prevStatus = this.bookmarked
			const newStatus = prevStatus === 1 ? 0 : 1

			try {
				if (newStatus === 1) {
					this.handleBookmarkList()
				} else {
					this.handleRemoveBookmark()
				}
				this.bookmarked = newStatus
				await this.toggleBookmark({
					user_id: this.currentUser.user_id,
					bookmark_entity_type: this.speaker.bookmark.bookmark_entity_type,
					bookmark_status: newStatus,
					bookmark_entity_id: this.speaker.bookmark.bookmark_entity_id,
				})
			} catch (e) {
				console.error(e)
				this.bookmarked = prevStatus
			}
		},
		handleBookmarkList() {
			this.sendTrigger({
				category: 'Speakers',
				action: 'click_speaker_bookmark_list',
				module: 'Events',
				title: this.speaker.speaker_name,
				id1: this.speaker.speaker_id,
				id2: this.$route.query.event_id,
			})
		},
		handleRemoveBookmark() {
			this.sendTrigger({
				category: 'Speakers',
				action: 'click_speaker_remove_bookmark_list',
				module: 'Events',
				title: this.speaker.speaker_name,
				id1: this.speaker.speaker_id,
				id2: this.$route.query.event_id,
			})
		},
		handleTriggerSpeaker() {
			const actionType =
				this.$route.name === 'event-session-speakers'
					? 'click_speaker_profile_session'
					: 'click_speaker_profile_event'
			this.sendTrigger({
				category: 'Speakers',
				action: actionType,
				module: 'Events',
				title: this.speaker.speaker_name,
				id1: this.speaker.speaker_id,
				id2: this.$route.params.id,
			})
		},
		goToSpeaker() {
			if (this.isMyBookmark) {
				this.$emit(
					'dwhClickBookmarkItem',
					this.speaker.speaker_name,
					this.speaker.speaker_id,
					this.$route.query.source
				)
			} else {
				this.handleTriggerSpeaker()
			}
			this.$router.push({
				name: 'speaker-by-id',
				params: { id: this.speaker.speaker_id },
				query: {
					event_id: this.$route.query.event_id,
				},
			})
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
		currentUser() {
			return this.profile
		},
	},
}
</script>
<style lang="scss">
.event-speaker-card {
	&__speaker {
		display: flex;
		justify-content: space-between;
		background: #ffffff;
		align-items: center;
		padding: 12px;
		border: 1px solid #e2e2e2;
		border-radius: 12px;
		margin-bottom: 8px;
		text-decoration: none;

		&-avatar {
			margin-right: 12px;
			border-radius: 8px;
		}
		&-info {
			display: flex;
			width: 100% !important;
			flex-direction: column;
			min-height: 52px;
		}

		&-name {
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			margin-bottom: 4px !important;
			color: var(--username-category-title);
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: normal;
		}
		&-title {
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--company-position-large);
			word-break: break-word;
			margin-top: 2px;
		}

		&-icon {
			color: #9b9b9b !important;
		}
	}
}
</style>
